import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { promisify } from 'app/actions';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { Section, Select, ViewModeSelector, Loader } from 'sa-ui';
import YearTabs from 'app/common/YearTabs';
import {
  getEvaluations,
  getEvaluationSteps,
  getGroups,
  // updateEvaluationCriteria,
} from './simulatedActions';

import messages from './simulatedMessages';
import SimulatedCard from './SimulatedCard';
import * as helpers from './simulatedHelpers';
// import SimulatedUpdateCriteriaModal from './SimulatedUpdateCriteriaModal';

import './SimulatedContainer.scss';

class SimulatedContainer extends PureComponent {
  static getDerivedStateFromProps(props, state) {
    if (props.years !== state.prevYears) {
      return {
        params: { ...state.params, year: state.params.year ? state.params.year : props.years[0] },
        prevYears: props.years,
      };
    }
    return null;
  }

  state = {
    params: { year: new Date().getFullYear(), status: undefined, application: undefined },
    page: 1,
    limit: 6,
    evaluationsFiltered: [],
    evaluationsPaginated: [],
    applicationOptions: [],
    isLoading: false,
  };

  async componentDidMount() {
    await this.props.getEvaluations({ year: new Date().getFullYear() });
    await this.props.getEvaluationSteps({
      role: 'school',
    });
    await this.props.getGroups();

    setTimeout(() => {
      const evaluationsFiltered = helpers.filterEvaluations(
        this.props.evaluations,
        this.state.params,
      );
      const evaluationsPaginated = helpers.paginate(
        evaluationsFiltered,
        this.state.page,
        this.state.limit,
      );
      const applicationOptions = helpers.getApplicationOptions(
        this.props.applications,
        this.props.intl,
      );

      this.setState({ evaluationsFiltered, evaluationsPaginated, applicationOptions });
    }, 1000);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.params.year !== this.state.params.year) {
      await this.props.getEvaluations({ year: this.state.params.year });
      this.setState({
        params: {
          ...this.state.params,
          page: 1,
        },
        page: 1,
      });
    }
    if (
      prevState.page !== this.state.page ||
      prevState.params.year !== this.state.params.year ||
      prevState.params.status !== this.state.params.status ||
      prevState.params.application !== this.state.params.application
    ) {
      const evaluationsFiltered = helpers.filterEvaluations(
        this.props.evaluations,
        this.state.params,
      );
      const evaluationsPaginated = helpers.paginate(
        evaluationsFiltered,
        this.state.page,
        this.state.limit,
      );
      const applicationOptions = helpers.getApplicationOptions(
        this.props.applications,
        this.props.intl,
      );
      this.setState({ evaluationsFiltered, evaluationsPaginated, applicationOptions });
    }
  }

  handleChangeFilter = (name) => (eventOrValue) => {
    const value = eventOrValue.target ? eventOrValue.target.value : eventOrValue;

    if (name === 'page') {
      return this.setState({
        [name]: value,
      });
    }

    this.setState({
      params: {
        ...this.state.params,
        [name]: value,
      },
    });
  };

  handleChangeState = (name) => (eventOrValue) => {
    const value = eventOrValue.target ? eventOrValue.target.value : eventOrValue;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { evaluationSteps, isLoading } = this.props;
    const { evaluationsFiltered, evaluationsPaginated, applicationOptions } = this.state;
    const statusOptions = evaluationSteps.map((el) => ({ value: el.id, label: el.name }));

    return (
      <Section id="simulated-container">
        <Loader show={isLoading} />
        <Row className="mb-5">
          <Col>
            <Row>
              <Col className="col-4" style={{ display: 'flex', alignItems: 'center' }}>
                <FormattedMessage {...messages.title}>
                  {(txt) => <h1 className="page-title">{txt}</h1>}
                </FormattedMessage>
              </Col>
              <Col className="col-6">
                <Select
                  containerClassName="mt-0"
                  onChange={this.handleChangeFilter('application')}
                  placeholder={this.props.intl.formatMessage(messages.application)}
                  options={applicationOptions}
                />
              </Col>
              {/* <Col>
                <Select
                  containerClassName="mt-0"
                  placeholder={this.props.intl.formatMessage(messages.status)}
                  onChange={this.handleChangeFilter('status')}
                  options={statusOptions}
                />
              </Col> */}
            </Row>
          </Col>
          <Col>
            <Row className="justify-content-md-end p-0 m-0">{/* <ViewModeSelector /> */}</Row>
          </Col>
        </Row>
        <YearTabs
          year={this.state.params.year}
          years={this.props.years}
          page={this.state.page}
          pages={Math.ceil(
            (evaluationsFiltered.length > 0
              ? evaluationsFiltered.length
              : evaluationsFiltered.length + 1) / this.state.limit,
          )}
          onChangePage={this.handleChangeFilter('page')}
          onChangeYear={this.handleChangeFilter('year')}
        />
        <Row>
          {!isLoading &&
            (evaluationsPaginated.length > 0 ? (
              evaluationsPaginated.map((d) => (
                <Col key={d.id} className="d-flex" lg={4}>
                  <SimulatedCard
                    {...d}
                    coordinator={this.props.coordinator}
                    style={{ paddingBottom: '15px' }}
                    onClick={() => this.props.history.push(`/simulated/${d.id}`)}
                  />
                </Col>
              ))
            ) : (
              <Col className="d-flex" lg={4}>
                {this.props.intl.formatMessage(messages.noCardsFound)}
              </Col>
            ))}
        </Row>
      </Section>
    );
  }
}

SimulatedContainer.defaultProps = {
  evaluations: [],
  applications: [],
  years: [new Date().getFullYear()],
};

const mapStateToProps = ({ app, simulated }) => ({
  user: app.user,
  coordinator: app.coordinator,
  ...simulated,
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    promisify(
      { getEvaluations, getEvaluationSteps, getGroups },
      {
        include: ['getEvaluations', 'getEvaluationSteps', 'getGroups'],
      },
    ),
  ),
)(SimulatedContainer);
